/**
 * WorkspaceContext — App.js stays the single owner of project state, but the
 * focus-mode components (BuildMode / InventoryMode / ResultsMode / CompareMode,
 * NodeInspector, NextStepCard) read it through this context instead of deep
 * prop-drilling. App builds the value once per render and provides it; consumers
 * call useWorkspace().
 */

import { createContext, useContext } from 'react';

export const WorkspaceContext = createContext(null);

export function useWorkspace() {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) throw new Error('useWorkspace must be used within a WorkspaceContext provider');
  return ctx;
}

export default WorkspaceContext;
